import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Mail } from "lucide-react";
import { useConsultation } from "../../../context/ConsultationContext";

const IMG =
  "https://images.unsplash.com/photo-1582719508461-905c673771fd?auto=format&fit=crop&w=1800&q=80";

export default function CTAV2() {
  const { open } = useConsultation();
  return (
    <section
      data-testid="v2-cta"
      className="relative isolate py-12 md:py-16 overflow-hidden"
    >
      <div className="absolute inset-0 -z-20">
        <img src={IMG} alt="" className="w-full h-full object-cover" loading="lazy" />
      </div>
      <div className="absolute inset-0 -z-10 bg-gradient-to-br from-[#001438]/95 via-[#002366]/90 to-[#001A4D]/95" />

      <div className="container-x relative text-center">
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="overline text-[#6B8AFF]"
        >
          Let's build in the UAE
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.05 }}
          className="mt-6 font-heading font-light tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl leading-tight max-w-4xl mx-auto"
        >
          Your UAE company — from first call to{" "}
          <span className="font-black text-[#6B8AFF]">first invoice</span>.
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="mt-6 max-w-2xl mx-auto text-slate-300/85 leading-relaxed"
        >
          A 20-minute call with a senior advisor. Written, transparent quote in
          24 hours. Fully operational entity in 4–6 weeks.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="mt-10 flex flex-col sm:flex-row gap-3 justify-center"
        >
          <button
            data-testid="v2-cta-primary"
            onClick={() => open("other")}
            className="btn-gold"
          >
            Get In Touch <ArrowRight className="w-4 h-4" />
          </button>
          <a
            href="mailto:contact@startinc.ae"
            className="btn-outline-gold"
          >
            <Mail className="w-4 h-4" /> contact@startinc.ae
          </a>
        </motion.div>
      </div>
    </section>
  );
}
